// src/extenders/collection-loader-handler.js
var LoadMore = class {
  constructor(button) {
    this.button = button;
    this.sectionId = button.getAttribute("data-section-id");
    this.nextPageUrl = button.getAttribute("data-url");
    this.productGrid = document.getElementById("main-collection-wrapper");
    this.loader = document.querySelector("[collection-loader]");
    this.productCount = document.querySelector("[data-product-count]");
    this.customProgressBar = document.querySelector("[data-product-loader-progress]");
    const totalCountElement = document.querySelector("[data-total-count]");
    const totalCountText = totalCountElement ? totalCountElement.textContent : "0";
    this.totalProducts = parseInt(totalCountText.replace(/[^\d]/g, ""), 10);
    this.shownProducts = this.productGrid.querySelectorAll(".product-card").length;
    console.log("Initialized LoadMore:", {
      totalProducts: this.totalProducts,
      shownProducts: this.shownProducts
    });
    this.init();
  }
  init() {
    if (!this.button || !this.productGrid)
      return;
    this.button.addEventListener("click", () => this.loadMoreProducts());
    this.updateProductCount();
    this.wrapProductSummaryItems();
  }
  async loadMoreProducts() {
    if (!this.nextPageUrl)
      return;
    try {
      this.loader.classList.remove("invisible", "opacity-0");
      const response = await fetch(`${this.nextPageUrl}&sections=${this.sectionId}`);
      const data = await response.json();
      this.loader.classList.add("invisible", "opacity-0");
      const newContent = document.createElement("div");
      newContent.innerHTML = data[this.sectionId];
      const newProducts = newContent.querySelectorAll(".product-card");
      console.log("Fetched products:", newProducts);
      newProducts.forEach((product) => {
        this.productGrid.appendChild(product);
        this.shownProducts++;
      });
      this.updateProductCount();
      const nextButton = newContent.querySelector("[data-load-more-button]");
      if (nextButton && nextButton.getAttribute("data-url")) {
        this.nextPageUrl = nextButton.getAttribute("data-url");
        this.button.setAttribute("data-url", this.nextPageUrl);
      } else {
        this.button.remove();
        console.log("No more products to load");
      }
      this.wrapProductSummaryItems();
    } catch (error) {
      console.error("Error loading more products:", error);
    }
  }
  wrapProductSummaryItems() {
    const productSummaryItems = document.querySelectorAll(".product-summary ul li");
    if (productSummaryItems.length > 2) {
      productSummaryItems.forEach((item) => {
        item.innerHTML = `<span>${item.textContent.trim()}</span>`;
      });
    }
  }
  updateProductCount() {
    this.productCount.textContent = `${this.shownProducts}`;
    const progressFraction = this.shownProducts / this.totalProducts * 100;
    console.log("Updating progress bar:", {
      shownProducts: this.shownProducts,
      totalProducts: this.totalProducts,
      progressFraction
    });
    this.customProgressBar.style.width = `${progressFraction}%`;
  }
};
document.addEventListener("DOMContentLoaded", () => {
  const loadMoreButton = document.querySelector("[data-load-more-button]");
  if (loadMoreButton) {
    new LoadMore(loadMoreButton);
  }
});
